// Cliente do relay SSE.
// publish(): POST pra /publish, fail-silent se relay não estiver up.
// subscribe(): EventSource pra /events, auto-reconnect (browser nativo).
//
// Sempre seguro chamar — se o relay não estiver rodando, vira no-op.

const DEFAULT_RELAY = "http://127.0.0.1:4174";

let cachedUrl: string | null = null;

function getRelayUrl(): string {
  if (cachedUrl) return cachedUrl;
  // Permite override via meta tag <meta name="relay-url" content="...">
  const meta = document.querySelector('meta[name="relay-url"]');
  cachedUrl = meta?.getAttribute("content") || DEFAULT_RELAY;
  return cachedUrl;
}

// Detecção early: se a página não está rodando em localhost/127.x, o relay
// dev não existe e tentar conectar gera CORS errors barulhentos no console.
// Pula publish/subscribe e cai direto em modo local-only.
function isLikelyDevHost(): boolean {
  if (typeof location === "undefined") return false;
  const h = location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "[::1]" || h.endsWith(".localhost");
}
const RELAY_AVAILABLE = isLikelyDevHost();
let publishWorks = RELAY_AVAILABLE;
let publishWarnedOnce = false;

export async function publish(payload: unknown): Promise<void> {
  if (!publishWorks) return;
  try {
    await fetch(`${getRelayUrl()}/publish`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (e) {
    publishWorks = false;
    if (!publishWarnedOnce) {
      publishWarnedOnce = true;
      console.info(
        `[relay-client] relay indisponível em ${getRelayUrl()} — modo local-only ` +
        `(monitor cross-process não funciona). Detalhe: ${(e as Error).message}`,
      );
    }
  }
}

export interface RelaySubscription {
  close(): void;
}

export function subscribe(onMessage: (data: unknown) => void): RelaySubscription {
  let es: EventSource | null = null;
  let closed = false;

  if (!RELAY_AVAILABLE) {
    // Em prod: relay não existe, não tenta. Devolve no-op subscription.
    return { close() { /* nothing to close */ } };
  }

  const connect = () => {
    if (closed) return;
    try {
      es = new EventSource(`${getRelayUrl()}/events`);
      es.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          onMessage(data);
        } catch (err) {
          console.warn("[relay-client] mensagem inválida do relay:", err);
        }
      };
      es.onerror = () => {
        // EventSource auto-reconecta; nada a fazer aqui exceto opcionalmente
        // logar. Mantém a flag pra que publish saiba que pode tentar de novo
        // depois (relay pode ter voltado).
        publishWorks = true;
      };
    } catch (e) {
      console.info(`[relay-client] subscribe falhou: ${(e as Error).message}`);
    }
  };
  connect();

  return {
    close() {
      closed = true;
      if (es) { try { es.close(); } catch { /* */ } es = null; }
    },
  };
}
